

  <!-- lưới chi tiết -->

    <div class="row">
      <div class="col-6">
        <div class="title-group">
          <div class="left-group">
            <span>{{'Danh sách các khoản phải thu' | translate}}</span>
          </div>
        </div>
        <div class="row" style="margin-left: -20px;margin-top: -10px;overflow:auto">
          <div style="padding: 2px 10px 10px 10px;color:black !important;height: calc(100vh - 200px)">
            <table id="fixTable4" class="table table-striped table-bordered table-hover table-condensed">
              <thead>
                <!--<thead>-->
                <tr>
                  <th style="width:90px;text-align:center;background-color:#f3f8fc">STT</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày tạo</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày đăng ký</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Khóa học</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Gói phí</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Giảm giá</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Thực thu</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Số buổi</th>
                  <th style="width:120px;text-align:center;background-color:#f3f8fc">Loại đăng ký</th>
                </tr>

                <tr class="filter-row">
                  <td style="text-align:center"></td>

                  <td></td>
                  <td></td>
                  <td style="font-weight:bold">Tổng</td>
                  <td style="text-align:right;font-weight:bold">{{tong_giaphi | number:'1.0-0'}}</td>
                  <td style="text-align:right;font-weight:bold">{{tong_giamgia | number:'1.0-0'}}</td>
                  <td style="text-align:right;font-weight:bold">{{tong_thucthu | number:'1.0-0'}}</td>
                  <td style="text-align:center;font-weight:bold">{{tong_sobuoi | number}}</td>
                  <td></td>




                </tr>

              </thead>
              <tbody style="max-height:calc(100vh - 250px);">
                <tr *ngFor="let u of datas">
                  <td style="width:90px;text-align:center"><a>{{u.STT}}</a></td>
                  <td style="min-width:100px"><a>{{u.Created | date:'dd/MM/yyyy'}}</a></td>
                  <td style="min-width:100px"><a>{{u.NgayDangKy | date:'dd/MM/yyyy'}}</a></td>
                  <td style="min-width:100px"><a>{{u.KhoaHoc}}</a></td>
                  <td style="min-width:110px;color:red;text-align:right">{{u.GiaPhi | number}}</td>
                  <td style="min-width:110px;color:red;text-align:right">{{u.DuocGiam | number}}</td>
                  <td style="min-width:110px;color:red;text-align:right">{{u.ThucThu | number}}</td>
                  <td style="min-width:110px;text-align:center">{{u.SoBuoi}}</td>
                  <td style="min-width:120px">{{u.LoaiDangKy}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="width:100%">
          <div>
            <ul class="pagination">
              <li [ngClass]="{disabled: currentPage === 1}">
                <a (click)="setPage(1)"><<</a>
              </li>
              <li [ngClass]="{disabled:currentPage === totalPages}">
                <a (click)="setPage(currentPage + 1)">></a>
              </li>
              <li *ngFor="let page of pages" [ngClass]="{active: currentPage === page.Id}">
                <a (click)="setPage(page.Id)">{{page.Id}}</a>
              </li>
              <li [ngClass]="{disabled:currentPage === 1}">
                <a (click)="setPage(currentPage - 1)"><</a>
              </li>
              <li [ngClass]="{disabled:currentPage === totalPages}">
                <a (click)="setPage(totalPages)">>></a>
              </li>
              <li>
                <input type="number" style="width:50px;height:23px;text-align:center" [(ngModel)]="pageSize" (blur)="search1()" />
              </li>
              <li><span style="font-weight:bold">Tổng số: {{totalItems | number}}</span></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="title-group">
          <div class="left-group">
            <span>{{'Danh sách đã thu' | translate}}</span>
          </div>
        </div>

        <div class="row" style="margin-left: -20px;margin-top: -10px;overflow:auto">
          <div style="padding: 2px 10px 10px 10px;color:black !important;height: calc(100vh - 200px)">
            <table id="fixTable5" class="table table-striped table-bordered table-hover table-condensed">
              <thead>
                <!--<thead>-->
                <tr>
                  <th style="width:90px;text-align:center;background-color:#f3f8fc">STT</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày tạo</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Ngày nộp</th>
                  <th style="width:100px;text-align:center;background-color:#f3f8fc">Quyển</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Số phiếu</th>
                  <th style="width:110px;text-align:center;background-color:#f3f8fc">Số tiền</th>
                </tr>
                <tr class="filter-row">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td style="font-weight:bold">Tổng</td>
                  <td style="text-align:right;font-weight:bold">{{tong_tien | number:'1.0-0'}}</td>

                </tr>

              </thead>
              <tbody style="max-height:calc(100vh - 250px);">
                <tr *ngFor="let u of data2s">
                  <td style="width:90px;text-align:center"><a>{{u.STT}}</a></td>
                  <td style="min-width:100px"><a>{{u.Created | date:'dd/MM/yyyy'}}</a></td>
                  <td style="min-width:100px"><a>{{u.NgayNop | date:'dd/MM/yyyy'}}</a></td>
                  <td style="min-width:100px"><a>{{u.QuyenSo}}</a></td>
                  <td style="min-width:110px">{{u.SoPhieu}}</td>
                  <td style="min-width:110px;color:red;text-align:right">{{u.SoTien | number}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div style="width:100%">
          <div>
            <ul class="pagination">
              <li [ngClass]="{disabled: currentPage === 1}">
                <a (click)="setPage2(1)"><<</a>
              </li>
              <li [ngClass]="{disabled:currentPage2 === totalPage2s}">
                <a (click)="setPage2(currentPage2 + 1)">></a>
              </li>
              <li *ngFor="let page of page2s" [ngClass]="{active: currentPage2 === page.Id}">
                <a (click)="setPage2(page.Id)">{{page.Id}}</a>
              </li>
              <li [ngClass]="{disabled:currentPage === 1}">
                <a (click)="setPage2(currentPage2 - 1)"><</a>
              </li>
              <li [ngClass]="{disabled:currentPage2 === totalPage2s}">
                <a (click)="setPage2(totalPage2s)">>></a>
              </li>
              <li>
                <input type="number" style="width:50px;height:23px;text-align:center" [(ngModel)]="pageSize2" (blur)="search21()" />
              </li>
              <li><span style="font-weight:bold">Tổng số: {{totalItem2s | number}}</span></li>
            </ul>
          </div>
        </div>
      </div>
      
    </div>








  <div class="modal-footer" style="display: flex;justify-content: space-between;margin-top:5px;">
    <div>
      
    </div>
    <div class="">
      <button class="mb-1 mr-1 btn btn-secondary" (click)="save_chondoituong()" title="Ấn ESC để thoát" style="padding-top:0px !important">Đóng lại</button>
    </div>

  </div>


  
